<template functional>
  <div
    class="d-flex gap-2 mt-1"
    :class="[props.isOneLine ? 'align-center' : 'flex-column', data.staticClass]"
    v-bind="data.attrs"
  >
    <div class="d-flex gap-2 flex-wrap">
      <v-tooltip v-if="props.mixedUse" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.PropertyTypeChip"
            property-type="Mixed Use"
            class="wide-chip"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Property Type</span>
      </v-tooltip>
      <v-tooltip v-if="props.type" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.PropertyTypeChip"
            :property-type="props.type"
            class="wide-chip"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Property Type</span>
      </v-tooltip>
      <v-tooltip v-if="props.buildingClass" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.CommonChip"
            class="wide-chip"
            dark
            color="black"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.buildingClass }}
          </component>
        </template>
        <span>Building Class</span>
      </v-tooltip>
      <v-tooltip v-if="props.showTransactionStatus && props.transactionStatus" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.CommonChip"
            class="wide-chip"
            dark
            color="grey darken-2"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.transactionStatus }}
          </component>
        </template>
        <span>Transaction Status</span>
      </v-tooltip>
    </div>
    <div v-if="props.contractPending || props.leasePending" class="d-flex gap-2 flex-wrap">
      <component
        :is="$options.components.AvailabilityTransactionStatusChip"
        v-if="props.contractPending"
        status="In Escrow"
        class="wide-chip"
      />
      <component
        :is="$options.components.CommonChip"
        v-if="props.leasePending"
        status="Lease Pending"
        class="wide-chip"
        color="#9CA88F"
        dark
      >
        Lease Pending
      </component>
    </div>
    <div v-if="props.status || props.inHouse || props.agencyType" class="d-flex gap-2" :class="{'flex-wrap': props.allowWrap}">
      <v-tooltip v-if="props.status" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.AvailabilityStatusChip"
            :status="props.status"
            class="wide-chip"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Status</span>
      </v-tooltip>
      <component
        :is="$options.components.CommonChip"
        v-if="props.inHouse"
        class="wide-chip"
        dark
        color="green"
      >
        In House
      </component>
      <v-tooltip v-if="props.agencyType" bottom>
        <template #activator="{ on, attrs }">
          <component
            :is="$options.components.CommonChip"
            class="wide-chip"
            :color="props.agencyType === 'Exclusive' ? 'green' : 'grey darken-3'"
            dark
            v-bind="attrs"
            v-on="on"
          >
            {{ props.agencyType }}
          </component>
        </template>
        <span>Agency Type</span>
      </v-tooltip>
      <component
        :is="$options.components.CommonChip"
        v-if="props.isPublishedToWeb"
        dark
        color="green"
        class="wide-chip"
      >
        <v-icon size="20" class="mr-1">mdi-web</v-icon>
        Published To Web
      </component>
    </div>
    <div v-if="props.isPortfolio">
      <component
        :is="$options.components.CommonChip"
        dark
        color="#A020F0"
        class="wide-chip"
      >
        Portfolio
      </component>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import AvailabilityStatusChip from '@/bundles/Availabilities/components/AvailabilityStatusChip.vue';
import AvailabilityTransactionStatusChip from '@/bundles/Availabilities/components/AvailabilityTransactionStatusChip.vue';
import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';
import PropertyTypeChip from '@/components/properties/PropertyTypeChip.vue';

export default Vue.extend({
  name: 'AvailabilityChipsWrapper',

  components: {
    CommonChip,
    AvailabilityStatusChip,
    PropertyTypeChip,
    AvailabilityTransactionStatusChip
  },

  props: {
    inHouse: Boolean,
    agencyType: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    vacancyType: {
      type: String,
      default: ''
    },
    buildingClass: {
      type: String,
      default: ''
    },
    transactionStatus: {
      type: String,
      default: ''
    },
    contractPending: Boolean,
    isPortfolio: Boolean,
    isOneLine: Boolean,
    mixedUse: Boolean,
    isPublishedToWeb: Boolean,
    allowWrap: Boolean,
    showTransactionStatus: Boolean,
    leasePending: Boolean,
  }
});
</script>

<style lang="scss">
.availabilities-chips-wrapper {
  height: 25px !important;
  background-color: transparent!important;
  .v-chip:hover {cursor: default!important;}
  .v-toolbar__content {
    height: 24px !important;
    padding: 4px 0!important;
  }
}
</style>
